import crestImg from "../assets/photos/logo-crest.png";
import fullImg from "../assets/photos/logo-full.png";

export const MagnusCrest = ({ className = "" }) => (
    <img
        src={crestImg}
        alt="Símbolo Magnus"
        aria-hidden="true"
        draggable={false}
        className={className}
    />
);

export const MagnusLogoFull = ({ className = "" }) => (
    <img
        src={fullImg}
        alt="Magnus Personalizados"
        draggable={false}
        className={className}
    />
);

export const MagnusCrestSvg = ({ className = "" }) => (
    <svg
        viewBox="0 0 64 64"
        fill="none"
        className={className}
        aria-hidden="true"
    >
        <defs>
            <linearGradient
                id="magnusGoldSvg"
                x1="8"
                y1="4"
                x2="56"
                y2="60"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#E5C36A" />
                <stop offset="0.45" stopColor="#C5A059" />
                <stop offset="1" stopColor="#8F6F35" />
            </linearGradient>
        </defs>
        <g
            stroke="url(#magnusGoldSvg)"
            strokeLinecap="round"
            fill="none"
        >
            <path d="M32 3.5 36.5 10.2 32 16.9 27.5 10.2Z" strokeWidth="1.5" />
            <path d="M32 17v3.5" strokeWidth="1.4" />
            <path
                d="M23 41.5v-9c0-5.8 4-9.8 9-9.8s9 4 9 9.8v9"
                strokeWidth="1.8"
            />
            <path d="M32 21.5v7" strokeWidth="1.5" />
            <path d="M25.5 28.5h13" strokeWidth="1.5" />
            <path
                d="M23 41.5c0 4.6 4 8 9 8s9-3.4 9-8"
                strokeWidth="1.5"
            />
            <path d="M14.5 45.5C10.5 37.5 12 26.5 19.5 19.5" strokeWidth="1.2" />
        </g>
        <g fill="url(#magnusGoldSvg)">
            <ellipse cx="11.5" cy="40" rx="1.5" ry="3.1" transform="rotate(-70 11.5 40)" />
            <ellipse cx="11.3" cy="33.5" rx="1.5" ry="3.1" transform="rotate(-83 11.3 33.5)" />
            <ellipse cx="12.3" cy="27.2" rx="1.5" ry="3.1" transform="rotate(-63 12.3 27.2)" />
            <ellipse cx="14.6" cy="22" rx="1.5" ry="3" transform="rotate(-48 14.6 22)" />
            <ellipse cx="17.6" cy="17.8" rx="1.5" ry="3" transform="rotate(-33 17.6 17.8)" />
            <ellipse cx="29" cy="51.5" rx="3" ry="1.5" transform="rotate(24 29 51.5)" />
            <ellipse cx="35" cy="51.5" rx="3" ry="1.5" transform="rotate(-24 35 51.5)" />
        </g>
        <g stroke="url(#magnusGoldSvg)" strokeLinecap="round" fill="none">
            <path d="M49.5 45.5c4-8 2.5-19-5-26" strokeWidth="1.2" />
        </g>
        <g fill="url(#magnusGoldSvg)">
            <ellipse cx="52.5" cy="40" rx="1.5" ry="3.1" transform="rotate(70 52.5 40)" />
            <ellipse cx="52.7" cy="33.5" rx="1.5" ry="3.1" transform="rotate(83 52.7 33.5)" />
            <ellipse cx="51.7" cy="27.2" rx="1.5" ry="3.1" transform="rotate(63 51.7 27.2)" />
            <ellipse cx="49.4" cy="22" rx="1.5" ry="3" transform="rotate(48 49.4 22)" />
            <ellipse cx="46.4" cy="17.8" rx="1.5" ry="3" transform="rotate(33 46.4 17.8)" />
        </g>
    </svg>
);

export const MagnusLogo = ({ light = false, size = "w-10" }) => (
    <span className="flex items-center gap-3">
        {light ? (
            <MagnusCrestSvg className={`${size} shrink-0`} />
        ) : (
            <MagnusCrest className="h-11 w-auto shrink-0" />
        )}
        <span className="flex flex-col leading-none">
            <span
                className={`font-accent font-semibold tracking-[0.18em] text-lg leading-none ${
                    light ? "text-cream" : "text-gold-gradient"
                }`}
            >
                MAGNUS
            </span>
            <span
                className={`font-accent text-[8px] tracking-[0.4em] mt-1.5 leading-none ${
                    light ? "text-gold" : "text-gold-deep"
                }`}
            >
                PERSONALIZADOS
            </span>
        </span>
    </span>
);
